
export default {
  name: 'RuleIP',
  props: ['setting', 'origin', 'is_setup', 'ip_lock'],
  computed: {},
  watch: {
    setting() {
      this.server = Object.assign({}, this.server, this.setting)
    },
    origin() {
      this.model = Object.assign({}, this.model, this.origin)
    }
  },
  data: () => {
    return {
      explain_ip_allow :false,
      explain_ip_block_or_detect : false,
      model : { allow_ip : '', block_ip : '' },
      server : { mode : 0, level : 1 }
    }
  },
  methods: {
    refresh() {
      // some action here
      this.$parent.$emit("refresh")
    },
    block_ip($value, key) {
      location.hostname == 'localhost' ? console.info('update block_ip RuleIP => parent', $value, key) : ''
      this.$parent.$emit('block_ip', $value, key)
    },
    allow_ip($value, key) {
      location.hostname == 'localhost' ? console.info('update allow_ip RuleIP => parent', $value, key) : ''
      this.$parent.$emit('allow_ip', $value, key)
    }
  },
  created: function() {   console.log('RuleIP.vue', 'created'); },
  destroyed: function() { console.log('RuleIP.vue', 'destroyed'); },
  mounted: function() {
    console.log('RuleIP.vue', 'mounted');
    this.model = Object.assign({}, this.model, this.origin)
    this.server = Object.assign({}, this.server, this.setting)
  }
}
